// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import Trend from 'vuetrend';
import VueCountdownTimer from 'vuejs-countdown-timer'
Vue.use(Trend);

// v-calendar
import VCalendar from 'v-calendar';
Vue.use(VCalendar);

import {
  Toasted,
  error,
  errorOptions,
  success,
  successOptions
} from '@/services/vue-toasted';
Vue.use(Toasted)
Vue.toasted.register('error', error, errorOptions);

Vue.toasted.register('success', success, successOptions);


//Nprogress
import 'nprogress/nprogress.css'
Vue.use(Buefy, {

})

Vue.use(VueCountdownTimer)

//money filter
Vue.filter('money', function (money) {
  if (typeof money != 'number') money = parseFloat(money);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(money)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js